'use client'

import { cn } from '@/core/utils/common'

import { fmt } from '@/features/veluvit/lib/format'
import { useSessionStore } from '@/features/veluvit/stores/session.store'

/**
 * 보유 젬 구성 — 한 줄 막대(유료 · 보너스 · 출석 비율) + 아래 범례(색 점 · 이름 · 개수). 충전소 · 마이가 같이 쓴다.
 * 소멸 기한(보너스 30일 · 출석 7일)은 각 화면의 규정 문구가 맡는다 — 여기엔 숫자만.
 */
export default function GemLots({ className }: { className?: string }) {
  const walletLots = useSessionStore((state) => state.data?.wallet.lots)
  const lots = walletLots ?? { paid: 0, bonus: 0, attendance: 0 }
  // 막대 조각과 범례 점이 같은 색을 쓴다
  const LOTS: [string, number, string][] = [
    ['유료', lots.paid, 'bg-foreground/75'],
    ['보너스', lots.bonus, 'bg-sub'],
    ['출석', lots.attendance, 'bg-point'],
  ]
  const held = lots.paid + lots.bonus + lots.attendance
  return (
    <div className={className}>
      {held > 0 && (
        <div
          aria-hidden="true"
          className="mb-2.5 flex h-1.5 gap-0.5 overflow-hidden rounded-full"
        >
          {LOTS.filter(([, value]) => value > 0).map(([label, value, tone]) => (
            <span
              key={label}
              style={{ flexGrow: value }}
              className={cn('basis-0 rounded-full', tone)}
            />
          ))}
        </div>
      )}
      <dl className="flex flex-wrap gap-x-4 gap-y-1 text-c12 over10:text-c13">
        {LOTS.map(([label, value, tone]) => (
          <div key={label} className="flex items-center gap-1.5">
            <span
              aria-hidden="true"
              className={cn('size-1.5 rounded-full', tone)}
            />
            <dt className="text-t3">{label}</dt>
            <dd className="font-bold text-t1 tabular-nums">{fmt(value)}</dd>
          </div>
        ))}
      </dl>
    </div>
  )
}
